<template style="background-color: white;">
    <div class="div" style="background-color: white;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div style="display: flex; height: 100vh; background-color: #ccccff;" v-if="leraner_marksheet != ''">
            <div class="column pr-7" style="height: 90vh;">
                <img class="img_back pl-10 pt-10 pb-10 pr-10" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/marksheet_school_image/marksheet_img_prep.png" height="70%" width="100%" />
                <center>
                    <table style="width: 90%; border: none !important; background-color: #5229cc; color: white;margin-top: -10px;">
                        <tbody>
                        <tr class="table" style="font-weight: bold;"><th class="table"  colspan="2"><center>Grade Key</center></th></tr>
                        <tr class="table" v-for="g,index in leraner_marksheet.grading_scheme_details_for_marksheet" :key="index">
                            <th style="width: 10%; border: none !important;">
                                <img  :src="g.grade_range_display_name" alt=""  width="35%" />
                                <!-- <img  src="@/assets/marksheet_img/dotted_line_2.svg" alt=""  width="35%" /> -->
                            </th>
                            <th style="width: 30%;  text-align: left; font-weight: bold; border: none !important;" class="pl-2"><strong>{{ g.graderemark }}</strong></th>
                        </tr>
                    </tbody>
                    </table>
                </center>
            </div>
            <div class="column pl-7" style="align-items: center; justify-content: center; display: flex;">
                <div class="column" style=" align-items: center; justify-content: center;">
                    <center><img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="120px" height="120px" alt="logo" /></center>
                    <span style="text-transform: uppercase; font-weight: bolder; color: #450676;"> <center>{{ org_basic_data.trust_name }}</center> </span>
                    <span style="color: #450676;"><center>{{ marksheet_addr_line_1 }}</center></span>
                    <span style="color: #450676;"><center>{{ marksheet_addr_line_2 }}</center></span>
                   <center>
                        <img :src="marksheet_img" alt="" width="600px" height="300px" class="mt-1" />
                    </center>
                    <br />
                    <span style="text-transform: uppercase;  font-weight: bolder; color: #5229cc;"> <center>Report Card - {{ ay }}</center> </span> <br />
                    <div class="row pl-10" style="text-transform: uppercase; font-weight: bolder; margin-top: -25px;">
                        <div  class="col-12 mt-2 pt-2" style="padding-right: 15%;padding-left: 5%;">
                            <div class="row" style="border-bottom: #450676 1px solid;">
                                Name :
                                <div style="width: 70%; margin-left: 5px;"> <span v-if="name_as_on_aadhar_card!='' && name_as_on_aadhar_card!=null">{{ name_as_on_aadhar_card }} </span> <span v-else>{{ name }} <span class="pl-1"></span> {{ sur_name }}</span></div>
                            </div>
                        </div>
                        <div class="col-6" style="padding-left: 5%;">
                            <div class="row" style="border-bottom: #450676 1px solid;" >
                                std : {{ standard }}
                            </div>
                        </div>
                        <div class="col-6" style="padding-right: 15%;">
                            <div class="row" style="border-bottom: #450676 1px solid;">
                                Div : {{ div }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="mt-2 pt-2" style="text-transform: uppercase; font-size: x-large; font-weight: bolder;"><center>{{ay}}</center></div> -->
            </div>
        </div>
        <div class="pagebreak pt-1" style="display: flex; height: 100vh; border-top: 25px solid #5229cc !important;" v-if="leraner_marksheet != ''">
            <div class="column pr-7">
                <div v-for="s in leraner_marksheet.leraner_marksheet" :key="s.c_id">
                    <div class="table-breaked">
                        <span v-if="s.crs_image_list != ''" class="image">
                            <v-row style="position: absolute;">
                                <v-col cols="12" sm="4" md="4" style="position: relative;" v-for="ci, index in s.crs_image_list" :key="index">
                                    <!-- <img :src="ci.file" v-if="index == 0" style="z-index: 1;opacity: 0.5;" width="80px" height="80px;"
                                        alt="logo" class="ci-image " /> -->
                                        <img :src="ci.file" v-if="index == 0" style="left:2250%; position: absolute;opacity: 0.6" width="80px" height="80px" alt="logo"
                                        class="ci-image" />
                                    <!-- <img :src="ci.file" v-else style="position: absolute; left: 950%;z-index: 1;opacity: 0.5" width="80px" height="80px" alt="logo"
                                        class="ci-image " /> -->
                                </v-col>
                            </v-row>
                        </span>
                        <!-- <img class="overlay-image" src="your-image.jpg" alt="Overlay Image"> -->
                        <v-simple-table class="pl-5" flat dense>
                            <thead>
                                <tr>
                                    <th class="suject_head crs_name">
                                        <strong>{{ s.crs_name }}</strong>
                                    </th>
                                    <th class="suject_head"><strong>Final</strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(header, index) in s.rubric_header" :key="index">
                                    <td class="fixed-width-rubric pt-1 pb-1" style="font-weight: 500;line-height: 100%;">
                                      <span style="z-index: 2000 !important;position: relative;">{{ header }}</span>  
                                    </td>
                                    <td>
                                        <!-- {{ s.rubrics[index] }} -->
                                        <img v-if="s.rubrics[index] != ''" :src="s.rubrics[index]" alt="" width="80%" class="pt-1" />
                                        <span v-if="s.rubrics[index] == ''"> </span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
                <div class="column">
                    <img class="pl-5 resolution-width" src="@/assets/img_start_1.png" alt="" width="90px" height="85px" />
                    <img style="margin-left: 25%;" class="pl-5 resolution-width" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws1course_image/course-264/Crs_Image2640ymgxzb6xd3.jpg " alt="" width="90px" height="85px" />
                    <img style="margin-left: 30%;" class="resolution-width" src="@/assets/img_start_2.png" alt="" width="85px" height="90px" />
                </div>
            </div>
            <div class="column pl-7">
                <div v-for="s in leraner_marksheet.leraner_marksheet_crs_2" :key="s.c_id">
                    <div class="table-breaked">
                        <span v-if="s.crs_image_list != ''" class="image">
                            <v-row style="position: absolute;">
                                <v-col cols="12" sm="6" md="6" style="position: relative;" v-for="ci, index in s.crs_image_list" :key="index">
                                    <!-- <img :src="ci.file" v-if="index == 0" style="z-index: 1;opacity: 0.5;" width="80px" height="80px;"
                                        alt="logo" class="ci-image " />
                                    <img :src="ci.file" v-else style="position: absolute; left: 950%;z-index: 1;opacity: 0.5" width="80px" height="80px" alt="logo"
                                        class="ci-image " /> -->
                                        <img :src="ci.file" v-if="index == 0" style="left: 2250%;position: absolute; opacity: 0.6" width="80px" height="80px" alt="logo"
                                        class="ci-image" />
                                </v-col>
                            </v-row>
                        </span>
                        <v-simple-table class="pr-5" flat dense>
                            <thead>
                                <tr>
                                    <th class="suject_head crs_name">
                                        <strong>{{ s.crs_name }}</strong>
                                    </th>
                                    <th class="suject_head"><strong>Final</strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(header, index) in s.rubric_header" :key="index">
                                    <td class="fixed-width-rubric pt-1 pb-1" style="font-weight: 500;line-height: 100%;">
                                      <span style="z-index: 2000 !important;position: relative;">{{ header }}</span>  
                                    </td>
                                    <td>
                                        <img v-if="s.rubrics[index] != ''" :src="s.rubrics[index]" alt="" width="80%" class="pt-1" />
                                        <span v-if="s.rubrics[index] == ''"> </span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
                <div class="mt-3">
                    <table class="mt-3 pr-2" style="width: 97.5%;">
                        <tr>
                            <td class="pt-2 pb-2 pl-2 " style="width: 88.2%; border-right: 2px solid black"><strong>ATTENDANCE</strong></td>

                            <td class="diagonalCross2"> 
                                <!-- {{ attendance_list_overall }} -->
                                <strong>
                                    <span style="position: relative; left: 7%; top: -5px;">
                                        <!-- {{ leraner_marksheet.attendance_list_overall[0].present }} -->
                                    </span>
                                    <span class="pt-2 ml-5" style="position: absolute; right: 2.5%;">
                                        <!-- {{ leraner_marksheet.attendance_list_overall[0].total_working_stud }} -->
                                    </span>
                                </strong>
                            </td>
                        </tr>
                    </table>
                    <table class="mt-3 pr-2" style="width: 97.5%;">
                        <tr>
                            <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>CLASS TEACHER’S NAME</strong></td>

                            <td class="pl-2"><strong>{{ inst_name }}</strong></td>
                        </tr>
                    </table>
                    <table class="mt-3 pr-2" style="width: 97.5%;">
                        <tr>
                            <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>PRINCIPAL’S SIGNATURE</strong></td>

                            <td class="pl-2">
                                <strong>  
                                <img v-if="org_id=='1'"  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="100px" height="50px" alt="logo" /> 
                                <img v-else  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/2/chatgptimagesep22,2026,10_28_47amkz4i3o070g.png" width="100px" height="50px" alt="logo" /> 
                            </strong>
                            </td>
                        </tr>
                    </table>
                    <table class="mt-3 pr-2" style="width: 97.5%;">
                        <tr>
                            <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>PARENT’S SIGNATURE</strong></td>

                            <td></td>
                        </tr>
                    </table>
                    <table class="mt-3 pr-2" style="width: 97.5%;">
                        <tr>
                            <td class="pt-2 pb-2 pl-2" style="width: 50%;"><strong>PROMOTED TO</strong></td>

                            <td class="pl-2"> <strong>{{ next_std }} - </strong> </td>
                        </tr>
                    </table>
                </div>
                <div class="column">
                    <img class="pl-5 resolution-width" src="@/assets/img_end_1.png" alt="" width="100px" height="100px" />
                    <img class="pl-5 resolution-width" style="margin-left: 25%;" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws1course_image/course-263/Crs_Image263nsdm2eey938.jpg " alt="" width="100px" height="100px" />
                    <img class="resolution-width" style="margin-left: 25%;" src="@/assets/img_end_2.png" alt="" width="100px" height="100px" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                inst_name: null,
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                next_std:null,
                semester: null,
                div: null,
                ay: null,
                name: null,
                name_as_on_aadhar_card:null,
                dob: null,
                roll_no: null,
                mobile_no: null,
                address: null,
                mother_name: null,
                photo: null,
                reg_no: null,
                gr_no: null,
                father_full_name: null,
                leraner_marksheet: [],
                colspan: null,
                overall_grade: null,
                remark: [],
                grading_scheme_details_for_marksheet: [],
                org_basic_data: [],
                marksheet_img: null,
                attendance_list_overall:[],
                marksheet_addr_line_1:null,
                marksheet_addr_line_2:null,
                org_id:null,
            };
        },

        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const data = {
                    lid: this.registration_no,
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    org: this.org,
                };
                axios
                    .post("/WWSExamination/getLearnerMarksheetPrePrim", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.next_std = res.data.next_std;
                            this.semester = res.data.semester;
                            this.div = res.data.div;
                            this.ay = res.data.ay;
                            this.name = res.data.name;
                            this.name_as_on_aadhar_card = res.data.name_as_on_aadhar_card
                            this.dob = res.data.dob;
                            this.roll_no = res.data.roll_no;
                            this.mobile_no = res.data.mobile_no;
                            this.address = res.data.address;
                            this.mother_name = res.data.mother_name;
                            this.photo = res.data.photo;
                            this.reg_no = res.data.reg_no;
                            this.gr_no = res.data.gr_no;
                            this.father_full_name = res.data.father_full_name;
                            this.leraner_marksheet = res.data.leraner_marksheet;
                            this.inst_name = res.data.inst_name;
                            this.org_basic_data = res.data.org_basic_data;
                            this.marksheet_img = res.data.marksheet_img;
                            this.attendance_list_overall = res.data.attendance_list_overall
                            this.marksheet_addr_line_1 = res.data.marksheet_addr_line_1
                            this.marksheet_addr_line_2 = res.data.marksheet_addr_line_2
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            handleKeyDown(event) {
                // Check if the key pressed is 'P' and the Ctrl key is also pressed
                if ((event.key === "p" || event.key === "P") && (event.ctrlKey || event.metaKey)) {
                    // Prevent the default behavior (in this case, printing)
                    event.preventDefault();
                    alert("Can't take print.");
                }
            },
        },
        beforeDestroy() {
            // Remove the keydown event listener when the component is destroyed
            document.removeEventListener("keydown", this.handleKeyDown);
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.sem = localStorage.getItem("setsem");
            this.registration_no = localStorage.getItem("setreg_no");
            this.org_id = localStorage.getItem("EPS-org-id")
            this.onload();
            document.addEventListener("keydown", this.handleKeyDown);
        },
    };
</script>
<style scoped>
    .image {
        overflow: hidden;
        display: flex;
        /* justify-content: flex-end; */
    }

    .container {
      position: relative;
      width: 100%;
    }

    .overlay-image {
    position: relative;
      top: 0;
      left: 0;
      /* width: 10%;
      height: 10%; */
      z-index: 1; /* Ensure the image is displayed above the table */
      opacity: 0.5; /* Optional: Adjust the opacity of the image */
    }

    .ci-image {
        margin: 0;
        padding: 0;
        /* margin-left: 20px;
    margin-top: 0; */
        /* justify-content: flex-end; */
        display: block;
    }

    .suject_head {
        text-transform: uppercase !important;
        /* font-size: 16px !important; */
        font-weight: bold !important;
        color: black !important;
    }

    .fixed-width-rubric {
        width: 620px;
    }
    .diagonalCross2 {
        background: linear-gradient(to top left, #fff calc(50% - 1px), black, #fff calc(50% + 1px));
    }

    .table {
        border: 1px solid white !important;
        /* font-size: 17px; */
        /* border-radius: 50px !important; */
    }

    table,
    th,
    td {
        /* font-size: 17px; */
        border: 1px solid black;
        border-collapse: collapse;
    }

    .th {
        border: 1px solid black;
        border-bottom: 1px solid black;
        /* font-size: 17px; */
    }

    .column {
        flex: 1; /* Each column takes up equal width */
        padding: 10px;
        /* border: 1px solid #ccc;
      box-sizing: border-box; */
    }
    @media screen and (resolution: 1.5dppx){
    .div{
        font-size: small !important;
    }
    .resolution-width{
        max-width: 80px;
        max-height: 80px;
    }
    .ci-image{
        max-width:40px ;
        max-height: 40px;
        left: 1990% !important; 
        position: absolute;
    }
    .pagebreak{
        height: 140vh !important;
    }
    }
    @media print {
        .svg-content {
            width: 35%;
            /* height: 50%; */
        }

        .img_back {
            height: 80%;
            width:100%;
        }
        .pagebreak {
            page-break-before: always;
        }

        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        v-card {
            border: none !important;
        }

        @page {
            /* size: A4; */
            margin-top: none;
            padding-top: none;
            size: 15in 10in !important;
            margin: 0mm;
            /* margin-top: -1.2645833mm; */
        }
        .crs_name {
            width: 410px;
        }
        .table-breaked {
            page-break-inside: avoid;
            margin-top: 1rem;
        }
    }
</style>
